import React from 'react'
import { Button } from 'antd'
import './index.css'

interface ButtonWhiteProps {
  buttonText?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  htmlType?: 'submit' | 'button' | 'reset';
  holderStyles?: React.CSSProperties;
  buttonStyles?: React.CSSProperties;
  onClick?: () => void;
}

const ButtonWhite: React.FC<ButtonWhiteProps> = ({
  buttonText = 'Submit',
  loading = false,
  disabled = false,
  htmlType = 'submit',
  holderStyles = {},
  buttonStyles = {},
  onClick = () => {},
}) => {
  return (
    <div style={holderStyles} className="button-holder-white">
      <Button
        type="primary"
        htmlType={htmlType}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        style={buttonStyles}
      >
        {buttonText}
      </Button>
    </div>
  )
}

export default ButtonWhite
